
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.057 4h-6.891a1.81 1.81 0 00-1.944 1.63v1.066H6.867A1.877 1.877 0 005 8.578v9.54A1.877 1.877 0 006.867 20h7.043a1.877 1.877 0 001.867-1.882v-.815h1.28A1.809 1.809 0 0019 15.674V5.63A1.809 1.809 0 0017.057 4zm-2.213 14.118a.939.939 0 01-.934.941H6.867a.939.939 0 01-.934-.941v-9.54a.939.939 0 01.934-.941h7.043a.939.939 0 01.934.941zm3.223-2.444c0 .373-.463.688-1.01.688h-1.28V8.578a1.877 1.877 0 00-1.867-1.882H9.156V5.63c0-.373.462-.689 1.01-.689h6.891c.547 0 1.01.316 1.01.689z","fill":"currentColor"}})])
          )
        }
      }
    